import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import 'leaflet/dist/leaflet.css';
import ApkModal from "./components/ApkModal";
import PrivateRoute from "./pages/PrivateRoute";
import PublicRoute from "./pages/PublicRoute";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import EmergencySos from "./pages/EmergencySos";
import OfficerApp from "./pages/OfficerApp";
import SectorPatrol from "./pages/SectorPatrol";
import Booths from "./pages/booths";
import SubDivisions from "./pages/subdivisions";
import Circle from "./pages/circle";
import Station from "./pages/stations";
import LiveOfficersMapPage from "./pages/LiveOfficersMap";
import User from "./pages/user";

function LegacyRedirect({ to }) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}

export default function App() {
  return (
    <>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
        </Route>

        {/* ADMIN AND COMMANDER ROUTES */}
        <Route
          element={
            <PrivateRoute allowedRoles={["ADMIN", "OFFICER"]} />
          }
        >
          <Route path="/admin" element={<Admin />} />
          <Route path="/emergency-sos" element={<EmergencySos />} />
          <Route path="/sector-patrol" element={<SectorPatrol />} />
          <Route path="/booths" element={<Booths />} />
          <Route path="/sub-divisions" element={<SubDivisions />} />
          <Route path="/circles" element={<Circle />} />
          <Route path="/stations" element={<Station />} />
          <Route
            path="/live-officer-map"
            element={<LiveOfficersMapPage />}
          />
          <Route path="/officers" element={<User />} />
        </Route>

        {/* OFFICER APP */}
        <Route
          element={<PrivateRoute allowedRoles={["OFFICER"]} />}
        >
          <Route path="/officer-app" element={<OfficerApp />} />
        </Route>

        {/* UNAUTHORIZED */}
        <Route
          path="/unauthorized"
          element={
            <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-3xl font-bold">Access Denied</h1>
                <p className="text-slate-400 mt-2">
                  You don't have permission to access this page.
                </p>
              </div>
            </div>
          }
        />

        {/* LEGACY REDIRECTS */}
        <Route path="/index.html" element={<LegacyRedirect to="/" />} />
        <Route path="/login.html" element={<LegacyRedirect to="/login" />} />
        <Route path="/admin.html" element={<LegacyRedirect to="/admin" />} />
        <Route
          path="/emergency-sos.html"
          element={<LegacyRedirect to="/emergency-sos" />}
        />
        <Route
          path="/officer-app.html"
          element={<LegacyRedirect to="/officer-app" />}
        />
        <Route
          path="/sector-patrol.html"
          element={<LegacyRedirect to="/sector-patrol" />}
        />

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ApkModal />
    </>
  );
}